import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Select from 'react-select';

import chevron from '../../../images/blue-chevron-down.svg';
import chevronBlack from '../../../images/chevron-down-black.svg';
import chevronVelvet from '../../../images/chevron-velvet.svg';

// * Styling the package and its children

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  &.overflow-carousel-filter {
    border: 2px solid ${themeGet('colors.black')};
    border-radius: 2rem;
  }
`;

export const Label = styled.label`
  color: ${themeGet('colors.secondary-text')};
  font-size: 0.875rem;
  line-height: 1.5rem;

  &.hide {
    font-size: 1rem;
    font-weight: 400;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const StyledSelect = styled(Select)`
  /* min-width: 165px; */
  width: 100%;

  /* Creates Pill Shape */
  &.left-round-border {
    .react-select__control {
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }
  }

  /* Creates Pill Shape */
  &.right-round-border {
    .react-select__control {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }

  &.calculator {
    .react-select__control {
      width: 100%;
      height: 2.8125rem;
      border-radius: 0.25rem;
      border: 1px solid #d9d9d9;
      background: #fff;
      text-align: right;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        max-width: 8.125rem;
        float: right;
        clear: both;
      }
    }

    .react-select__indicator.react-select__dropdown-indicator {
      &::after {
        background-image: url(${chevronVelvet});
        width: 0.6875rem;
        height: 0.375rem;
      }
    }
  }

  // * The main control div
  .react-select__control {
    border: none;
    border-radius: 0px;
    justify-content: flex-start;
    cursor: pointer;
  }

  .react-select__control--is-disabled {
  }

  // * Placeholder styling
  .react-select__placeholder {
  }

  // * Vertical line that seperates the placeholder from the indicator
  .react-select__indicator-separator {
    display: none;
  }

  .react-select__option,
  .react-select__placeholder,
  .react-select__single-value {
    font-family: ${themeGet('fonts.noir')};
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.medium')};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${themeGet('colors.main-text')};
  }

  .react-select__menu {
    border-radius: 0;
    /* padding: 0px;
    margin: 0px; */
  }

  .react-select__menu-list {
    padding: 0px;
    /* margin: 0px; */
  }

  .react-select__option {
    padding: 12px 20px;

    &:hover,
    &:focus {
      background-color: ${themeGet('colors.border-grey')};
    }
  }

  .react-select__option--is-focused {
    background-color: ${themeGet('colors.border-grey')};

    &:hover,
    &:focus {
      background-color: ${themeGet('colors.border-grey')};
    }
  }

  .react-select__option--is-selected {
    background-color: ${themeGet('colors.light-grey')};

    &.react-select__option--is-focused {
      background-color: ${themeGet('colors.border-grey')};
    }
  }

  .react-select__indicator.react-select__dropdown-indicator {
    &::after {
      content: '';
      background-image: url(${chevron});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 15px;
      height: 15px;
    }

    svg {
      display: none;
    }
  }

  &.overflow-carousel-filter {
    width: 250px;
    .react-select__control {
      background-color: transparent;
    }
    .react-select__indicator.react-select__dropdown-indicator {
      &::after {
        background-image: url(${chevronBlack});
        width: 15px;
        height: 8px;
      }
    }
    .react-select__single-value {
      font-size: 18px;

      /* &:hover,
      &:focus {
        background-color: ${themeGet('colors.border-grey')};
      } */
    }
    .react-select__option {
      font-size: 16px;
      font-weight: ${themeGet('fontWeights.normal')};
    }
  }
`;

export const SelectWrapper = styled.div`
  position: relative;

  ${SelectContainer}.calculator & {
    width: 100%;
  }
`;

export const Blockquote = styled.blockquote`
  position: absolute;
  top: -4.5rem;
  left: 0;
  font-size: 0.75rem;
  display: block;
  width: auto;
  min-width: 10rem;
  min-height: 2.5rem;
  padding: 0.5rem;
  background-color: ${themeGet('colors.white')};
  box-shadow: 0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.2);
  z-index: 9999;

  ${SelectContainer}.calculator & {
    left: calc(-100% - 2rem);

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      left: 0;
    }
  }
`;
